import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import Btn from "components/Custom/Btn";
import SkeletonBox from "components/Custom/SkeletonBox";

import { LABELS, SUCCESS, WARNINGS } from "common/lables";
import { COLORS } from "common/colors";
import { CRM_LEAD_STATUS, NOTIFY } from "common/config";
import { COMMON_JS } from "common/scripts";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { USER_APIs } from "apihandlers/user";
import { GEO_APIs } from "apihandlers/geography";

const Assign = (props: any) => {
  const { data, areas, onClose } = props;
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [toUsers, setToUsers] = useState([]);
  const [byUsers, setByUsers] = useState([]); // todo: get only marketing users
  const [selectedRow, setSelectedRow] = useState<any>({});

  const toUsersRef: any = useRef(null);
  const byUsersRef: any = useRef(null);
  const areasRef: any = useRef(null);

  useEffect(() => {
    if (loading) {
      loadInitData();
    }
  }, [loading]);

  const loadInitData = async () => {
    try {
      const args = {};
      const res: any = await USER_APIs.getUsers(args);
      if (res.status === 200) {
        const users = res.response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setToUsers(users);
        setByUsers(users);
        const res2: any = await CUSTOMER_APIs.getCrmLeadAssigned({
          crmLeadId: data.id,
        });
        if (res2.status === 200) {
          const recs = res2.response.records;
          if (recs.length > 0) {
            setSelectedRow(recs[recs.length - 1]);
          } else {
            setSelectedRow({});
          }
        }
        setLoading(false);
      }
    } catch (error) {
      console.log("loadInitData: error:", error);
    }
  };

  const saveRecord = async () => {
    try {
      const args = {
        id: selectedRow.id || -1,
        crmLeadId: data.id,
        assignedToId: toUsersRef.current.selectedValue.id,
        assignedById: byUsersRef.current.selectedValue.id,
        assignedDate: (
          document.getElementById("assignedDate") as HTMLInputElement
        ).value,
        areaId: areasRef.current.selectedValue.id,
        comments: (
          document.getElementById("assignComments") as HTMLInputElement
        ).value,
      };
      if (
        !args.assignedToId ||
        !args.assignedById ||
        !args.assignedDate ||
        !args.areaId ||
        !args.comments
      ) {
        COMMON_JS.showNotify(
          props,
          NOTIFY.WARNING,
          WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
        );
        return;
      }
      setIsSubmit(true);
      const res: any = await CUSTOMER_APIs.manageLeadAssigned(args);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        onClose(true);
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, "Error: " + res.error);
      }
      setIsSubmit(false);
      console.log("saveRecord: ", args, res);
    } catch (error) {
      setIsSubmit(false);
      console.log("saveRecord: error:", error);
    }
  };

  console.log("selectedRow: ", selectedRow);

  return loading ? (
    <div>
      <SkeletonBox height={50} width={"100%"} style={{ marginBottom: 15 }} />
      <SkeletonBox height={50} width={"100%"} style={{ marginBottom: 15 }} />
      <SkeletonBox height={50} width={"100%"} style={{ marginBottom: 15 }} />
      <SkeletonBox height={50} width={"100%"} style={{ marginBottom: 15 }} />
      <SkeletonBox height={100} width={"100%"} style={{ marginBottom: 15 }} />
      <div
        className="flexRow"
        style={{ justifyContent: "space-evenly", marginTop: 30 }}
      >
        <SkeletonBox height={30} width={"20%"} style={{ marginBottom: 15 }} />
        <SkeletonBox height={30} width={"20%"} style={{ marginBottom: 15 }} />
      </div>
    </div>
  ) : (
    <div>
      <div className="formGroup required">
        <label>
          {LABELS.ASSIGNED_TO}
          <span>{" *"}</span>
        </label>
        <AutoComplete
          list={toUsers}
          childRef={toUsersRef}
          required={true}
          defaultValue={
            selectedRow.id
              ? {
                  id: selectedRow.assignedToId,
                  label: selectedRow.assignedToUser,
                }
              : null
          }
          disabled={isSubmit}
        />
      </div>
      <div className="formGroup required">
        <label>
          {LABELS.ASSIGNED_BY}
          <span>{" *"}</span>
        </label>
        <AutoComplete
          list={byUsers}
          childRef={byUsersRef}
          required={true}
          defaultValue={
            selectedRow.id
              ? {
                  id: selectedRow.assignedById,
                  label: selectedRow.assignedByUser,
                }
              : null
          }
          disabled={isSubmit}
        />
      </div>
      <div className="formGroup required">
        <label>
          {LABELS.AREA}
          <span>{" *"}</span>
        </label>
        <AutoComplete
          list={areas}
          childRef={areasRef}
          required={true}
          defaultValue={
            selectedRow.id
              ? {
                  id: selectedRow.areaId,
                  label: selectedRow.areaName,
                }
              : null
          }
          disabled={isSubmit}
        />
      </div>
      <div className="formGroup">
        <TxtRow
          id={"assignedDate"}
          type={"date"}
          label={LABELS.ASSIGNED_DATE}
          required={true}
          defaultValue={selectedRow.id && selectedRow.assignedDate}
          disabled={isSubmit}
        />
      </div>
      <div className="formGroup">
        <TxtRow
          id={"assignComments"}
          label={LABELS.COMMENTS}
          required={true}
          rows={3}
          defaultValue={selectedRow.id && selectedRow.comments}
          disabled={isSubmit}
        />
      </div>
      <div
        className="formGroup flexRowAround"
        style={{
          width: "50%",
          margin: "auto",
          marginTop: 20,
          marginBottom: 10,
        }}
      >
        <div className="width30">
          <Btn text={LABELS.SAVE} loading={isSubmit} onClick={saveRecord} />
        </div>
        <div className="width30">
          <Btn
            text={LABELS.CANCEL}
            bgColor={COLORS.DIM_DARK_GRAY}
            disabled={isSubmit}
            onClick={() => onClose(false)}
          />
        </div>
      </div>
    </div>
  );
};

export default withSnackbar(Assign);
